import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { Helmet } from 'react-helmet-async';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-neutral-950">
      <Helmet>
        <title>Terms of Service - Cardston Market</title>
        <meta name="description" content="Read the Terms of Service for Cardston Market. By using our platform, you agree to these terms governing the marketplace connecting local vendors and shoppers." />
        <link rel="canonical" href="https://www.cardstonmarket.com/terms" />
        <meta property="og:title" content="Terms of Service - Cardston Market" />
        <meta property="og:description" content="Read the Terms of Service for Cardston Market governing the marketplace connecting local vendors and shoppers." />
        <meta property="og:url" content="https://www.cardstonmarket.com/terms" />
        <meta name="twitter:card" content="summary" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Terms of Service",
          "description": "Terms of Service for Cardston Market marketplace.",
          "url": "https://www.cardstonmarket.com/terms",
          "isPartOf": { "@id": "https://www.cardstonmarket.com/#website" },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.cardstonmarket.com/" },
              { "@type": "ListItem", "position": 2, "name": "Terms of Service", "item": "https://www.cardstonmarket.com/terms" }
            ]
          }
        })}</script>
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <h1 className="text-4xl font-serif font-medium text-neutral-900 dark:text-white mb-8 tracking-tight">Terms of Service</h1>
        
        <div className="prose prose-neutral dark:prose-invert max-w-none text-neutral-600 dark:text-neutral-400 font-light leading-relaxed space-y-8">
          <p className="text-lg text-neutral-900 dark:text-neutral-200">Last Updated: April 2026</p>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Cardston Market (the "Platform"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">2. Description of Service</h2>
            <p>
              Cardston Market provides a platform that connects local makers, artisans, and vendors with consumers. We act solely as a marketplace and are not the seller of the items listed by independent vendors.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">3. User & Vendor Responsibilities</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Users must provide accurate information during account creation.</li>
              <li>Vendors are responsible for the accuracy of their product listings, fulfillment of orders, and defining their own store policies.</li>
              <li>Any disputes regarding products, shipping, or returns must be handled directly between the buyer and the vendor through our messaging platform.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">4. Privacy Policy</h2>
            <p>
              Your use of the Platform is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-medium text-neutral-900 dark:text-white mt-12 mb-4">5. Limitation of Liability</h2>
            <p>
              Cardston Market is not liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the Platform.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
